








import { Component, Mixins } from 'vue-property-decorator'
import window from 'bits/global'

const FOCUSABLE_ELEMENTS_QUERY = [
  'a[href]',
  'area[href]',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])',
  'button:not([disabled]):not([aria-hidden])',
  'iframe',
  'object',
  'embed',
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])',
].join(', ')

let allFocusTraps: FocusTrap[] = []

@Component({})
export default class FocusTrap extends Mixins() {
  mounted(): void {
    allFocusTraps.unshift(this)
    this.initializeFocus()
    window.addEventListener('keydown', this.ensureFocusTrapped)
  }

  beforeDestroy(): void {
    allFocusTraps = allFocusTraps.filter((trap) => trap !== this)
    allFocusTraps[0]?.initializeFocus()
    window.removeEventListener('keydown', this.ensureFocusTrapped)
  }

  afterFocusShiftsFlushed(callback): void {
    // Only check and ensure focus is contained after a 1ms `setTimeout`.
    // This is to allow `focus()` calls on child elements to take place first.
    // For that to happen, these calls should happen immediately or by a 0ms `setTimeout` at the latest.
    setTimeout(() => this.$nextTick(callback), 1)
  }

  initializeFocus(): void {
    this.afterFocusShiftsFlushed(() => {
      const isLatestModal = allFocusTraps[0] === this
      if (!isLatestModal) return

      const isAlreadyTrapped = this.$el.contains(window.document.activeElement)
      if (isAlreadyTrapped) return

      const rootNode = this.$el as HTMLDivElement
      rootNode.focus()
    })
  }

  getFocusTarget(): Element | null {
    const rootNode = this.$el
    const activeElement = window.document.activeElement
    if (!activeElement) return rootNode

    const relativePosition = activeElement && this.$el.compareDocumentPosition(activeElement)
    const isAlreadyTrapped = relativePosition & Node.DOCUMENT_POSITION_CONTAINED_BY
    if (isAlreadyTrapped) return null

    const isFocusOnParent = relativePosition & Node.DOCUMENT_POSITION_CONTAINS
    if (isFocusOnParent) return rootNode

    const focusableChildren = rootNode.querySelectorAll(FOCUSABLE_ELEMENTS_QUERY)
    if (focusableChildren.length < 1) return rootNode

    if (relativePosition & Node.DOCUMENT_POSITION_FOLLOWING) return focusableChildren[0]
    if (relativePosition & Node.DOCUMENT_POSITION_PRECEDING) return focusableChildren[focusableChildren.length - 1]

    return rootNode
  }

  ensureFocusTrapped(): void {
    this.afterFocusShiftsFlushed(() => {
      const isLatestModal = allFocusTraps[0] === this
      if (!isLatestModal) return

      const focusTarget = this.getFocusTarget()
      if (focusTarget) (focusTarget as HTMLElement).focus()
    })
  }
}
